module.exports = __webpack_public_path__ + "img/calendar.d9853e04.svg";